import React from "react";
// import axios from "axios";

export default function WeatherFooter() {
  return (
    <div className="weather-footer">
      <p className="codeLink">
        <a href="https://github.com/letloleT/weather-react">
          Open-source code,
        </a>{" "}
        By Tshepang
      </p>
    </div>
  );
}
